import { render, staticRenderFns } from "./CreateVault.vue?vue&type=template&id=1b1a822f&"
import script from "./CreateVault.vue?vue&type=script&lang=js&"
export * from "./CreateVault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports